<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="mb-lg">
            <div class="card" v-if="!isLoading">
              <argon-alert v-if="showAlert" color="danger">
                <strong>Alerta!</strong> Es necesario seleccionar una imagen!
              </argon-alert>
              <argon-alert
                v-if="showSuccess"
                color="success"
                :dismissible="true"
              >
                <strong>Completado!</strong> Campos guardados correctamente!
              </argon-alert>
              <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                  <h4 class="mb-0">Slider</h4>
                </div>
              </div>
              <div class="card-body">
                <p class="text-uppercase text-sm">META</p>
                <hr class="horizontal dark" />
                <div class="row">
                  <div class="col-6">
                    <img
                      v-if="imageLocal !== undefined"
                      :src="imageLocal"
                      class="img-fluid"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Imagen</label
                    >
                    <argon-input
                      type="file"
                      id="2"
                      name="Imagen"
                      @change-image="onFileChange($event)"
                      accept="image/png, image/gif, image/jpeg, image/svg"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Titulo</label
                    >
                    <argon-input v-model="slider.title" id="0" name="Titulo" />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Descripción</label
                    >
                    <argon-textarea
                      v-model="slider.description"
                      id="1"
                      name="Descripción"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <argon-button
                      color="primary"
                      size="lg"
                      class="ms-auto"
                      @click-callback="finalValidation"
                      :fullWidth="true"
                      >Guardar</argon-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "slider-card",
  props: {
    sliderID: { type: String, required: true },
  },
  data() {
    return {
      isLoading: true,
      showAlert: false,
      showSuccess: false,
      valid: Array(4).fill(true),
      sliderIDLocal: this.sliderID,
      imageLocal: undefined,
      imageLocalSave: undefined,
      slider: {
        title: "",
        description: "",
        active: true,
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonAlert, ArgonTextarea },
  created() {
    // console.log("SLIDER SLIDER SLIDER");
    // console.log(this.sliderIDLocal);
    if (this.sliderIDLocal !== "0") {
      this.plain
        .get(`/sliders/${this.sliderIDLocal}`)
        .then((response) => {
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.imageLocal = response.data.image_url;
          this.imageLocalSave = response.data.image_url;
          delete response.data.image_url;
          this.slider = response.data;
          this.isLoading = false;
          // console.log("RESPONSE SLIDER");
          // console.log(this.slider);
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    } else {
      this.sliderIDLocal = undefined;
      this.isLoading = false;
    }
  },
  methods: {
    absoluteValidation(event) {
      this.showAlert = false;
      this.showSuccess = false;
      this.valid[event.inputIndex] = event.valid;
    },
    finalValidation() {
      if (this.valid.includes(false)) {
        this.showAlert = true;
        window.scrollTo(0, 0);
      } else {
        if (this.sliderIDLocal !== undefined) this.editSlider();
        else {
          // console.log(this.imageLocal);
          if (this.imageLocal !== undefined) this.createSlider();
          else {
            this.showAlert = true;
            window.scrollTo(0, 0);
          }
        }
      }
    },
    createSlider() {
      // console.log("CREANDO SLIDER");
      // console.log(this.slider);
      let formData = new FormData();

      Object.entries(this.slider).forEach(([key, value]) => {
        formData.append(`slider[${key}]`, value);
      });

      this.form
        .post("/sliders", formData)
        .then((response) => {
          // console.log("SLIDER creado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          this.sliderIDLocal = response.data.id; //SOLUCIONAR PROBLEMA DE ALERTAS AQUI ES CON LA NAVEGACION route y con una variable local
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.imageLocal = response.data.image_url;
          this.imageLocalSave = response.data.image_url;
          delete response.data.image_url;
          this.slider = response.data;
          // console.log("CREATE");
          // console.log(this.slider);
        })
        .catch((error) => {
          console.log("Error al crear SLIDERS", error);
        });
    },
    editSlider() {
      // console.log("PREPARANDO PARA EDITAR");
      // console.log(this.slider);
      let formData = new FormData();

      Object.entries(this.slider).forEach(([key, value]) =>
        formData.append(`slider[${key}]`, value)
      );
      this.form
        .patch(`/sliders/${this.sliderIDLocal}`, formData)
        .then((response) => {
          // console.log("SLIDER editado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.imageLocal = response.data.image_url;
          this.imageLocalSave = response.data.image_url;
          delete response.data.image_url;
          this.slider = response.data;
          // console.log("EDIT");
          // console.log(this.slider);
        })
        .catch((error) => {
          console.log("Error al editar SLIDERS", error);
        });
    },
    onFileChange(file) {
      // console.log("FILE");
      // console.log(file);
      if (file !== undefined) {
        this.imageLocal = URL.createObjectURL(file);
        this.slider.image = file;
        this.showAlert = false;
        // console.log("ON FILE CHANGE");
        // console.log(this.slider);
      } else {
        if (Object.keys(this.slider).includes("image"))
          delete this.slider.image;

        this.imageLocal = this.imageLocalSave;
      }
    },
  },
};
</script>